<template>
  <HubContainer id="adminUsersHub">

    <HubSection large icon="icon/hub/super-admin.svg"
                :title="$t('roles.ROLE_SUPER_ADMIN')"
                :description="$t('roles.ROLE_SUPER_ADMIN_description')"
                :buttonAction="goToSuperAdmin">
    </HubSection>

    <HubSection large icon="icon/hub/resellers.svg"
                :title="$t('roles.ROLE_DISTRIBUTOR')"
                :description="$t('roles.ROLE_DISTRIBUTOR_description')"
                :buttonAction="goToDistributors">
    </HubSection>

    <HubSection large icon="icon/hub/api-keys.svg"
                :title="$t('apiKeys.title')"
                :description="$t('apiKeys.description')"
                :buttonAction="goToApiKeys">
    </HubSection>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "adminUsersHub",

    components: { HubSection, HubContainer },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "users.title";
      this.$store.state.pageIcon = "icon/nav/users.svg";
    },

    methods: {
      goToSuperAdmin() {
        this.$router.push(this.$router.buildContext("/users/ROLE_SUPER_ADMIN"));
      },
      goToDistributors() {
        this.$router.push(this.$router.buildContext("/users/ROLE_DISTRIBUTOR"));
      },
      goToApiKeys() {
        this.$router.push(this.$router.buildContext("/api-keys"));
      }
    }
  }
</script>